/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-fallthrough */
/* eslint-disable max-len */
/* eslint-disable object-curly-newline */
import React, {
  useState, useEffect, useContext, useMemo,
} from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import { Search, Plus, Archive, RotateCcw, Trash2, Copy } from 'lucide-react';
import { sendRequest } from '../../api/shootAPI';
import API from '../../api/endpoints';
import DataTable from '../../components/DataTable';
import RowActionMenu from '../../components/RowActionMenu';
import ConfirmDialog from '../../components/ConfirmDialog';
import { UserContext } from '../../contexts/User';
import useQueryParams from '../../hooks/useQueryParams';
import AddProjectModal from './AddProjectModal';
import ProjectEditModal from './ProjectEditModal';

const AVATAR_PALETTE = [
  { bg: '#fdebe6', fg: '#b94f3c' },
  { bg: '#fde6d2', fg: '#F19235' },
  { bg: '#eef5ea', fg: '#53A551' },
  { bg: '#e8eef7', fg: '#4062E5' },
  { bg: '#f5e6f7', fg: '#9333ea' },
  { bg: '#e6f3f5', fg: '#165968' },
];

const avatarColors = (projectName) => {
  const str = String(projectName || '');
  let hash = 0;
  for (let i = 0; i < str.length; i += 1) {
    // eslint-disable-next-line no-bitwise
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  return AVATAR_PALETTE[Math.abs(hash) % AVATAR_PALETTE.length];
};

function Projects() {
  const {
    member, accessToken, redirect, updateTokens,
  } = useContext(UserContext);
  const [loading, setLoading] = useState(false);
  const [projects, setProjects] = useState([]);
  const [error, setError] = useState(null);
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [editLoading, setEditLoading] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [projectToEdit, setProjectToEdit] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [createLoading, setCreateLoading] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [projectToDelete, setProjectToDelete] = useState(null);
  const [showArchiveConfirm, setShowArchiveConfirm] = useState(false);
  const [showRestoreConfirm, setShowRestoreConfirm] = useState(false);
  const [projectToArchive, setProjectToArchive] = useState(null);
  const [projectToRestore, setProjectToRestore] = useState(null);
  const [archiveLoading, setArchiveLoading] = useState(false);
  const [restoreLoading, setRestoreLoading] = useState(false);

  const [activeTab, setActiveTab] = useState(0);
  const [searchTerm, setSearchTerm] = useState('');
  const [sortBy, setSortBy] = useState('');
  const [sortOrder, setSortOrder] = useState('asc');

  const [showDuplicateModal, setShowDuplicateModal] = useState(false);
  const [projectToDuplicate, setProjectToDuplicate] = useState(null);
  const [duplicateLoading, setDuplicateLoading] = useState(false);

  const handleSort = (column) => {
    if (sortBy === column) {
      setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc');
    } else {
      setSortBy(column);
      setSortOrder('asc');
    }
  };
  const isProjectArchived = (project) => project.isArchived === 1
  || project.isArchived === true || project.isArchived === '1';

  const getData = async () => {
    if (!member?.workspaceId) {
      console.error('No workspace ID available');
      return;
    }

    if (!accessToken) {
      console.error('No access token available');
      return;
    }

    try {
      setLoading(true);
      setError(null);

      const response = await sendRequest({
        method: 'GET',
        url: API.WORKSPACE.getProjects(member.workspaceId),
        headers: {
          Authorization: `Bearer ${accessToken}`,
          'Content-Type': 'application/json',
        },
      });

      if (response && response.data) {
        if (Array.isArray(response.data)) {
          setProjects(response.data);
        } else if (response.data.data && Array.isArray(response.data.data)) {
          setProjects(response.data.data);
        } else {
          console.error('Unexpected response format:', response);
          setError('Unexpected response format');
          setProjects([]);
        }
      } else if (response && Array.isArray(response)) {
        setProjects(response);
      } else {
        setProjects([]);
      }
    } catch (e) {
      console.error('Error fetching projects:', e);
      setError(e.message || 'Failed to fetch projects');
      setProjects([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (member?.workspaceId && accessToken) {
      getData();
    }
  }, [member?.workspaceId, accessToken]);

  const handleCreateProject = async (projectData) => {
    setCreateLoading(true);
    try {
      const { members, teams, ...basicProjectData } = projectData;

      const response = await sendRequest({
        method: 'POST',
        url: API.WORKSPACE.createProject(member.workspaceId),
        data: basicProjectData,
      });

      console.log(response);

      if (response?.success && response?.data) {
        if (members && (members.managers?.length > 0
           || members.members?.length > 0 || members.viewers?.length > 0)) {
          const projectId = response.data.id;
          console.log(response.data.id, projectId);

          const allSelectedMembers = new Set();
          members.managers?.forEach((member) => allSelectedMembers.add(member.id));
          members.members?.forEach((member) => allSelectedMembers.add(member.id));
          members.viewers?.forEach((member) => allSelectedMembers.add(member.id));

          if (allSelectedMembers.size > 0) {
            const projectMembers = Array.from(allSelectedMembers).map((memberId) => {
              const isManager = members.managers?.some((m) => m.id === memberId) || false;
              const isViewer = members.viewers?.some((m) => m.id === memberId) || false;

              return {
                memberId,
                isManager,
                isViewer,
              };
            });

            console.log('Adding members:', projectMembers);

            const membersResponse = await sendRequest({
              method: 'POST',
              url: API.WORKSPACE.addProjectMembers(member.workspaceId, projectId),
              data: { members: projectMembers },
            });

            if (!membersResponse.success) {
              console.error('Failed to add members:', membersResponse);
            }
          }
        }

        if (teams && teams.length > 0) {
          const projectTeams = teams.map((team) => ({
            teamId: team.id,
          }));

          const projectId = response.data.id;
          console.log('Adding teams:', projectTeams);

          const teamsResponse = await sendRequest({
            method: 'POST',
            url: API.WORKSPACE.addProjectTeams(member.workspaceId, projectId),
            data: { teams: projectTeams },
          });

          if (!teamsResponse.success) {
            console.error('Failed to add teams:', teamsResponse);
          }
        }

        getData();
        return true;
      }
      throw new Error('Failed to create project');
    } catch (error) {
      console.error('Error creating project:', error);
      throw error;
    } finally {
      setCreateLoading(false);
    }
  };

  const handleEditProject = async (updatedData) => {
    if (!projectToEdit) return;

    setEditLoading(true);
    try {
      const { members, teams, ...basicProjectData } = updatedData;

      const response = await sendRequest({
        method: 'PUT',
        url: API.WORKSPACE.updateProject(member.workspaceId, projectToEdit.id),
        data: basicProjectData,
      });

      if (response?.success || response?.data) {
        const projectId = projectToEdit.id;

        if (members) {
          const allSelectedMembers = new Set();
          members.managers?.forEach((member) => allSelectedMembers.add(member.id));
          members.members?.forEach((member) => allSelectedMembers.add(member.id));
          members.viewers?.forEach((member) => allSelectedMembers.add(member.id));

          if (allSelectedMembers.size > 0) {
            const projectMembers = Array.from(allSelectedMembers).map((memberId) => {
              const isManager = members.managers?.some((m) => m.id === memberId) || false;
              const isViewer = members.viewers?.some((m) => m.id === memberId) || false;
              return { memberId, isManager, isViewer };
            });

            await sendRequest({
              method: 'POST',
              url: API.WORKSPACE.addProjectMembers(member.workspaceId, projectId),
              headers: {
                Authorization: `Bearer ${accessToken}`,
                'Content-Type': 'application/json',
              },
              data: { members: projectMembers },
            });
          }
        }

        if (teams && Array.isArray(teams)) {
          const teamIds = teams.map((team) => team.id);

          await sendRequest({
            method: 'POST',
            url: API.WORKSPACE.addProjectTeams(member.workspaceId, projectId),
            headers: {
              Authorization: `Bearer ${accessToken}`,
              'Content-Type': 'application/json',
            },
            data: { teamIds },
          });
        }

        getData();
        setShowEditModal(false);
        setProjectToEdit(null);
        return true;
      }
    } catch (error) {
      console.error('Error updating project:', error);
      throw error;
    } finally {
      setEditLoading(false);
    }
  };

  const handleDeleteProject = async () => {
    setDeleteLoading(true);
    try {
      const response = await sendRequest({
        method: 'DELETE',
        url: API.WORKSPACE.deleteProject(member.workspaceId, projectToDelete.id),
        headers: {
          Authorization: `Bearer ${accessToken}`,
          'Content-Type': 'application/json',
        },
      });

      if (response?.success || response?.status === 200) {
        getData();
        setShowDeleteModal(false);
        setProjectToDelete(null);
      } else {
        throw new Error('Failed to delete project');
      }
    } catch (error) {
      console.error('Error deleting project:', error);
    } finally {
      setDeleteLoading(false);
    }
  };

  const filteredProjects = useMemo(() => {
    if (!projects || projects.length === 0) return [];

    return projects.filter((project) => {
      const isArchived = project.isArchived === 1 || project.isArchived === true || project.isArchived === '1';

      const matchesTab = activeTab === 0 ? !isArchived : isArchived;

      const matchesSearch = searchTerm.trim() === ''
        || (project.name && project.name.toLowerCase().includes(searchTerm.toLowerCase()));

      return matchesTab && matchesSearch;
    });
  }, [projects, activeTab, searchTerm]);

  const handleArchiveClick = (project) => {
    setProjectToArchive(project);
    setShowArchiveConfirm(true);
  };

  const handleRestoreClick = (project) => {
    setProjectToRestore(project);
    setShowRestoreConfirm(true);
  };

  const handleArchiveProject = async () => {
    if (!projectToArchive) return;

    setArchiveLoading(true);
    try {
      const requestData = { isArchived: true };

      const response = await sendRequest({
        method: 'PUT',
        url: API.WORKSPACE.updateProject(member.workspaceId, projectToArchive.id),
        headers: {
          Authorization: `Bearer ${accessToken}`,
          'Content-Type': 'application/json',
        },
        data: requestData,
      });

      if (response?.success) {
        await getData();
        setShowArchiveConfirm(false);
        setProjectToArchive(null);
      }
    } catch (error) {
      console.error('Error archiving project:', error);
    } finally {
      setArchiveLoading(false);
    }
  };

  const handleRestoreProject = async () => {
    if (!projectToRestore) return;

    setRestoreLoading(true);
    try {
      const requestData = { isArchived: false };

      const response = await sendRequest({
        method: 'PUT',
        url: API.WORKSPACE.updateProject(member.workspaceId, projectToRestore.id),
        headers: {
          Authorization: `Bearer ${accessToken}`,
          'Content-Type': 'application/json',
        },
        data: requestData,
      });

      if (response?.success) {
        await getData();
        setShowRestoreConfirm(false);
        setProjectToRestore(null);
      }
    } catch (error) {
      console.error('Error restoring project:', error);
    } finally {
      setRestoreLoading(false);
    }
  };

  const handleDuplicateProject = async () => {
    if (!projectToDuplicate) return;

    setDuplicateLoading(true);
    try {
      const duplicateData = {
        name: `${projectToDuplicate.name} (Copy)`,
        description: projectToDuplicate.description || '',
        billable: projectToDuplicate.billable,
        activity: projectToDuplicate.activity,
        idleTime: projectToDuplicate.idleTime,
        client: projectToDuplicate.client || '',
        isArchived: false,
      };

      console.log('Duplicating project with data:', duplicateData);

      const response = await sendRequest({
        method: 'POST',
        url: API.WORKSPACE.createProject(member.workspaceId),
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
        data: duplicateData,
      });

      console.log('Duplicate response:', response);

      const newProject = response?.data || response;

      if (newProject?.id) {
        const projectId = newProject.id;

        if (projectToDuplicate.projectMembers?.length > 0) {
          const projectMembers = projectToDuplicate.projectMembers.map((member) => ({
            memberId: member.memberId,
            isManager: member.isManager || false,
            isViewer: member.isViewer || false,
          }));

          await sendRequest({
            method: 'POST',
            url: API.WORKSPACE.addProjectMembers(member.workspaceId, projectId),
            headers: {
              Authorization: `Bearer ${accessToken}`,
            },
            data: { members: projectMembers },
          });
        }

        if (projectToDuplicate.projectTeams?.length > 0) {
          const projectTeams = projectToDuplicate.projectTeams.map((team) => ({
            teamId: team.teamId,
          }));

          await sendRequest({
            method: 'POST',
            url: API.WORKSPACE.addProjectTeams(member.workspaceId, projectId),
            headers: {
              Authorization: `Bearer ${accessToken}`,
            },
            data: { teams: projectTeams },
          });
        }

        await getData();
        setShowDuplicateModal(false);
        setProjectToDuplicate(null);
        return true;
      }
      console.error('Invalid project response:', response);
      throw new Error('Invalid response from server');
    } catch (error) {
      console.error('Error duplicating project:', error);
      throw error;
    } finally {
      setDuplicateLoading(false);
    }
  };

  const sortedProjects = [...filteredProjects].sort((a, b) => {
    if (!sortBy) return 0;

    let aValue; let
      bValue;

    switch (sortBy) {
      case 'Project Name':
        aValue = (a.name || '').toLowerCase();
        bValue = (b.name || '').toLowerCase();
        break;
      case 'Members':
        aValue = a.projectMembers?.length || 0;
        bValue = b.projectMembers?.length || 0;
        break;
      case 'Teams':
        aValue = a.projectTeams?.length || 0;
        bValue = b.projectTeams?.length || 0;
        break;
      case 'Todos':
        aValue = a.Todos || '';
        bValue = b.Todos || '';
        // eslint-disable-next-line
        if (!isNaN(aValue) && !isNaN(bValue)) {
          aValue = Number(aValue);
          bValue = Number(bValue);
        } else {
          aValue = aValue.toString().toLowerCase();
          bValue = bValue.toString().toLowerCase();
        }
        break;
      case 'Member Limits':
        aValue = a.MemberLimits;
        bValue = b.MemberLimits;
        if (!aValue || aValue === 'None') aValue = 0;
        if (!bValue || bValue === 'None') bValue = 0;
        aValue = Number(aValue) || 0;
        bValue = Number(bValue) || 0;
        break;
      default:
        aValue = a[sortBy] || '';
        bValue = b[sortBy] || '';
    }

    if (typeof aValue === 'number' && typeof bValue === 'number') {
      return sortOrder === 'asc' ? aValue - bValue : bValue - aValue;
    }
    const comparison = aValue.toString().localeCompare(bValue.toString());
    return sortOrder === 'asc' ? comparison : -comparison;
  });

  const queryParams = useQueryParams();
  const queryAccessToken = queryParams.get('accessToken');

  useEffect(() => {
    if (!accessToken && !queryAccessToken) {
      redirect('/workspaces');
    }
    if (queryAccessToken) {
      updateTokens({ accessToken: queryAccessToken });
    }
  }, []);

  useEffect(() => {
    if (accessToken && queryAccessToken) {
      redirect('/projects');
    }
  }, [accessToken, queryAccessToken, redirect]);

  const handleAddProject = () => {
    setShowCreateModal(true);
  };

  const activeCount = projects.filter((p) => !isProjectArchived(p)).length;
  const archivedCount = projects.filter((p) => isProjectArchived(p)).length;
  const TABS = [`Active (${activeCount})`, `Archived (${archivedCount})`];

  const columns = [
    {
      key: 'Project Name',
      label: 'Project Name',
      sortable: true,
      width: 280,
      flex: true,
      render: (project) => {
        const c = avatarColors(project.name || 'Untitled');
        return (
          <div className="flex items-center gap-3 min-w-0">
            <div
              className="w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0"
              style={{ backgroundColor: c.bg, color: c.fg, fontSize: 12, fontWeight: 600 }}
            >
              {(project.name || 'U').charAt(0).toUpperCase()}
            </div>
            <span className="font-medium text-ink-900 truncate">{project.name || 'Untitled Project'}</span>
          </div>
        );
      },
    },
    { key: 'Members', label: 'Members', sortable: true, width: 120, render: (p) => <span className="tabular-nums text-ink-700">{p.projectMembers?.length || 0}</span> },
    { key: 'Teams', label: 'Teams', sortable: true, width: 110, render: (p) => <span className="tabular-nums text-ink-700">{p.projectTeams?.length || 0}</span> },
    { key: 'Todos', label: 'Todos', sortable: true, width: 130, render: (p) => <span className="text-ink-700">{p.Todos || 'No Todos'}</span> },
    { key: 'Member Limits', label: 'Member Limits', sortable: true, width: 150, render: (p) => <span className="text-ink-700">{p.MemberLimits || 'None'}</span> },
    {
      key: 'action',
      label: '',
      width: 72,
      align: 'center',
      render: (project) => {
        const items = activeTab === 0 ? [
          { label: 'Edit Project', onClick: () => { setProjectToEdit(project); setShowEditModal(true); } },
          { label: 'Duplicate Project', onClick: () => { setProjectToDuplicate(project); setShowDuplicateModal(true); } },
          { label: 'Archive Project', onClick: () => handleArchiveClick(project) },
          { label: 'Delete Project', destructive: true, onClick: () => { setProjectToDelete(project); setShowDeleteModal(true); } },
        ] : [
          { label: 'Restore Project', onClick: () => handleRestoreClick(project) },
          { label: 'Delete Project', destructive: true, onClick: () => { setProjectToDelete(project); setShowDeleteModal(true); } },
        ];
        return <RowActionMenu ariaLabel={`Actions for ${project.name || 'project'}`} items={items} />;
      },
    },
  ];

  if (!accessToken || !member) {
    return <div className="p-6 text-sm text-ink-500">Loading…</div>;
  }

  return (
    <div>
      {error && (
        <div className="mx-4 mt-4 px-3 py-2 rounded-[8px] text-sm text-[#CC4525] bg-[#fdf3f1] border border-[#f3cfc6]" style={{ borderStyle: 'solid' }}>
          {`Error: ${error}`}
        </div>
      )}

      {/* Active / Archived sub-tabs */}
      <div className="flex items-center gap-1 px-4 pt-3 border-b border-rule" style={{ borderBottomStyle: 'solid' }}>
        {TABS.map((label, i) => {
          const active = activeTab === i;
          return (
            <button
              key={label}
              type="button"
              onClick={() => setActiveTab(i)}
              className={`relative inline-flex items-center px-3 py-2 text-sm bg-transparent border-0 cursor-pointer transition ${active ? 'text-brand-700 font-semibold' : 'text-ink-500 font-medium hover:text-ink-900'}`}
            >
              {label}
              {active && <span className="absolute left-3 right-3 bottom-0" style={{ height: 2, background: '#315285', borderRadius: 2 }} />}
            </button>
          );
        })}
      </div>

      {/* Header: title + subtitle left, search + add right */}
      <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between px-4 pt-4 pb-3">
        <div className="min-w-0">
          <h4 className="text-base font-semibold text-ink-900 mb-0.5">Projects</h4>
          <p className="text-sm text-ink-500">Create and manage projects to streamline team collaboration and tracking.</p>
        </div>
        <div className="flex flex-wrap items-center gap-2 flex-shrink-0">
          <div className="relative" style={{ height: 40, width: 240 }}>
            <Search size={14} className="text-ink-500 pointer-events-none" style={{ position: 'absolute', left: 12, top: '50%', transform: 'translateY(-50%)', zIndex: 1 }} />
            <input
              type="text"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              placeholder="Search projects"
              className="w-full rounded-[8px] bg-white text-ink-900 placeholder:text-ink-500 border border-rule focus:outline-none focus:border-brand-500"
              style={{ height: 40, paddingLeft: 36, paddingRight: 12, fontSize: 14, lineHeight: '20px', borderStyle: 'solid', boxSizing: 'border-box' }}
            />
          </div>
          <button
            type="button"
            onClick={handleAddProject}
            disabled={loading}
            className="inline-flex items-center gap-1.5 box-border h-10 px-4 rounded-[8px] text-sm font-semibold text-white bg-[#53A551] hover:bg-[#458a44] disabled:opacity-40 disabled:cursor-not-allowed transition flex-shrink-0"
          >
            <Plus size={16} />
            Add Project
          </button>
        </div>
      </div>

      <DataTable
        bare
        columns={columns}
        rows={sortedProjects}
        getRowKey={(p) => p.id}
        sortKey={sortBy}
        sortDir={sortOrder}
        onSort={handleSort}
        loading={loading}
        emptyText="No projects were found. Please add one!"
        minWidth={760}
      />

      <AddProjectModal
        open={showCreateModal}
        onClose={() => setShowCreateModal(false)}
        onSubmit={handleCreateProject}
        loading={createLoading}
        title="New Project"
      />

      <ProjectEditModal
        open={showEditModal}
        onClose={() => {
          setShowEditModal(false);
          setProjectToEdit(null);
        }}
        onSubmit={handleEditProject}
        loading={editLoading}
        projectData={projectToEdit}
      />

      {showDeleteModal && (
        <ConfirmDialog
          tone="danger"
          icon={<Trash2 size={24} />}
          title="Delete this project?"
          description={`You're about to delete "${projectToDelete?.name}". This action cannot be undone.`}
          confirmLabel="Delete"
          cancelLabel="Cancel"
          confirming={deleteLoading}
          onConfirm={handleDeleteProject}
          onCancel={() => !deleteLoading && (setShowDeleteModal(false), setProjectToDelete(null))}
        />
      )}

      {showDuplicateModal && (
        <ConfirmDialog
          tone="brand"
          icon={<Copy size={24} />}
          title="Duplicate this project?"
          description={`A copy of "${projectToDuplicate?.name}" will be created with its members and teams.`}
          confirmLabel="Duplicate"
          cancelLabel="Cancel"
          confirming={duplicateLoading}
          onConfirm={handleDuplicateProject}
          onCancel={() => !duplicateLoading && setShowDuplicateModal(false)}
        />
      )}

      {showArchiveConfirm && (
        <ConfirmDialog
          tone="brand"
          icon={<Archive size={24} />}
          title="Archive this project?"
          description={`"${projectToArchive?.name}" will be archived, but ongoing sessions in the project will continue until they end.`}
          confirmLabel="Archive"
          cancelLabel="Cancel"
          confirming={archiveLoading}
          onConfirm={handleArchiveProject}
          onCancel={() => !archiveLoading && setShowArchiveConfirm(false)}
        />
      )}

      {showRestoreConfirm && (
        <ConfirmDialog
          tone="success"
          icon={<RotateCcw size={24} />}
          title="Restore this project?"
          description={`"${projectToRestore?.name}" will be restored and can be used again for selected teams and members.`}
          confirmLabel="Restore"
          cancelLabel="Cancel"
          confirming={restoreLoading}
          onConfirm={handleRestoreProject}
          onCancel={() => !restoreLoading && setShowRestoreConfirm(false)}
        />
      )}
    </div>
  );
}

export default Projects;
